<script setup>
import { Head, usePage } from "@inertiajs/vue3";
import { useThemeSetting } from "@/Composable/ThemeSetting";
import { computed, defineAsyncComponent, onMounted, onUnmounted } from "vue";
import { useDisplay } from "vuetify";
import ContactForm from "@/Components/ContactForm.vue";
// New Shawaf Components
const ShawafHero = defineAsyncComponent(() => import("@/Components/ShawafLanding/ShawafHero.vue"));
const ShawafVideoHero = defineAsyncComponent(() => import("@/Components/ShawafLanding/ShawafVideoHero.vue"));
const ShawafAbout = defineAsyncComponent(() => import("@/Components/ShawafLanding/ShawafAbout.vue"));
const ShawafTips = defineAsyncComponent(() => import("@/Components/ShawafLanding/ShawafTips.vue"));
const ShawafBrands = defineAsyncComponent(() => import("@/Components/ShawafLanding/ShawafBrands.vue"));
const ShawafProducts = defineAsyncComponent(() => import("@/Components/ShawafLanding/ShawafProducts.vue"));
const ShawafStats = defineAsyncComponent(() => import("@/Components/ShawafLanding/ShawafStats.vue"));
const ShawafMission = defineAsyncComponent(() => import("@/Components/ShawafLanding/ShawafMission.vue"));
const NewStyle = defineAsyncComponent(() => import("@/Components/ShawafLanding/NewStyle.vue"));

// Existing Components (kept for footer/utility)
const BlogSection = defineAsyncComponent(() => import("@/Components/BlogSection.vue"));
const NewsLatterSub = defineAsyncComponent(() => import("@/Components/NewsLatterSubscribe.vue"));
const Schema = defineAsyncComponent(() => import("@/Components/Schema.vue"));

const { toggleTheme, isDark } = useThemeSetting();
const page = usePage();
const { mdAndUp } = useDisplay();

const props = defineProps({
    canLogin: Boolean,
    canRegister: Boolean,
});

const locale = computed(() => page.props.locale);
const settings = computed(() => page.props.setting);

onMounted(() => {
    const mainDiv = document.querySelector('.main-dev');
    if (mainDiv) mainDiv.classList.add('mt-0');
});

onUnmounted(() => {
    const mainDiv = document.querySelector('.main-dev');
    if (mainDiv) mainDiv.classList.remove('mt-0');
});
</script>

<template>

    <Head>
        <title head-key="title">
            {{ settings.site_seo_title[locale] || settings.site_title[locale] }} | {{ __t("home") }}
        </title>
        <meta head-key="description" name="description" :content="settings.site_descr[locale]" />
        <meta head-key="keywords" name="keywords" :content="settings.site_keywords[locale]" />
        <meta property="og:type" content="website" head-key="og:type" />
        <meta property="og:title" head-key="og:title" :content="settings.site_seo_title[locale]" />
        <meta property="og:description" head-key="og:description" :content="settings.site_descr[locale]" />
        <meta property="og:image" head-key="og:image" :content="$page.props.setting.home_logolight" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" :content="settings.site_seo_title[locale]" />
        <meta name="twitter:description" :content="settings.site_descr[locale]" />
        <meta name="twitter:image" :content="$page.props.setting.home_logolight" />
    </Head>
    <Schema type="web" />

    <div class="flex flex-col min-h-screen">
        <!-- <NewStyle /> -->
        <!-- Hero Section -->
        <ShawafVideoHero />
        <!-- <ShawafHero /> -->

        <!-- About Section -->
        <div id="shawaf-about">
            <ShawafAbout />
        </div>
        <!-- Mission & Industry Section -->
        <ShawafMission />
        <!-- Tips Section -->



        <!-- Brands Section -->
        <ShawafBrands />

        <!-- Products Section -->
        <ShawafProducts />


        <ShawafTips />

        <!-- Blog Section -->
        <BlogSection />
        <ContactForm />

        <!-- Newsletter -->
        <!-- <NewsLatterSub /> -->
    </div>
</template>

<style scoped>
.main-dev {
    margin-top: 0 !important;
}
</style>

```
